import { DatePicker } from '@mui/x-date-pickers-pro';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import dayjs, { Dayjs } from 'dayjs';
import { DecomPolicyFormValues } from '../../decom-policy-form-layout';

interface VaultDatePickerProps {
  day: number;
  idx: number;
  name:
    | `actions.${number}.actions.${number}.vaultStartTime`
    | `actions.${number}.actions.${number}.vaultEndTime`
    | `actions.${number}.actions.${number}.vaultVersionDate`;
  label: string;
  control: Control<DecomPolicyFormValues>;
  errors: FieldErrors<DecomPolicyFormValues>;
  minDate?: Dayjs;
  maxDate?: Dayjs;
}

export default function VaultDatePicker({
  day,
  idx,
  name,
  label,
  control,
  errors,
  minDate,
  maxDate,
}: VaultDatePickerProps) {
  // Extract nested error dynamically
  const actionErrors = errors.actions?.[day]?.actions?.[idx];
  const fieldName = name.split('.').pop() as
    | 'vaultStartTime'
    | 'vaultEndTime'
    | 'vaultVersionDate';
  const errorObj = actionErrors?.[fieldName];

  const handleDateChange = (
    newValue: Dayjs | null,
    onChange: (value: string | null) => void
  ) => {
    if (newValue === null) {
      onChange(null);
    } else {
      onChange(
        newValue.isValid() ? newValue.format('YYYY-MM-DD') : newValue.toString()
      );
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DatePicker
          value={field.value ? dayjs(field.value) : null}
          onChange={(newValue: Dayjs | null) =>
            handleDateChange(newValue, field.onChange)
          }
          format="MM/DD/YYYY"
          label={label}
          minDate={minDate}
          maxDate={maxDate}
          slotProps={{
            textField: {
              size: 'small',
              error: !!errorObj,
              helperText: errorObj?.message || 'Format: mm/dd/yyyy',
            },
          }}
        />
      )}
    />
  );
}
